import {FlexRow, Modal, Text} from '@forecast-it/design-system';
import React from 'react';
import {useIntl} from 'react-intl';
import {MODAL_TYPE, showModal} from '../../../shared/components/modals/generic_modal_conductor';
import {ModalProps} from '../../../shared/components/modals/types';

export type ResetOpportunityStagesModalPayload = {
	onReset: () => void;
};

export const showResetOpportunityStagesModal = (props: ResetOpportunityStagesModalPayload): void => {
	showModal({
		type: MODAL_TYPE.RESET_OPPORTUNITY_STAGES,
		...props,
	});
};

export const ResetOpportunityStagesModal = ({
	closeModal,
	onReset,
}: ModalProps<ResetOpportunityStagesModalPayload>): JSX.Element => {
	const {formatMessage} = useIntl();

	const handleReset = () => {
		try {
			onReset();
		} finally {
			// Closed whatever the reset does. It is not a bare state update: it sends a mutation and settles
			// what else is in flight, so it can throw on the way out — and closing only after it returned left
			// this dialog sitting over a page that could not be used until it was dismissed with Escape. The
			// failure is not swallowed, only the dialog stops depending on it.
			closeModal();
		}
	};

	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal} closeOnInteractOutside={false}>
			<Modal.Title>{formatMessage({id: 'settings.opportunity_stages.reset_modal.title'})}</Modal.Title>
			<Modal.Content>
				<Text>{formatMessage({id: 'settings.opportunity_stages.reset_modal.body'})}</Text>
				<FlexRow>
					<Modal.PrimaryFooterButton onPress={handleReset} dataCy="reset-opportunity-stages-confirm">
						{formatMessage({id: 'settings.opportunity_stages.reset_modal.confirm'})}
					</Modal.PrimaryFooterButton>
					{/* The label is passed as text, not as an element: the button derives its accessible name
					    by stringifying its children, so an element arrives as "[object Object]" and is read
					    out as that. */}
					<Modal.SecondaryFooterButton onPress={closeModal} dataCy="cancel">
						{formatMessage({id: 'common.cancel'})}
					</Modal.SecondaryFooterButton>
				</FlexRow>
			</Modal.Content>
		</Modal>
	);
};
